"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import {
  buildAttributionPayload,
  storeFirstTouchAttribution,
  storeLastTouchAttribution,
} from "@/lib/attribution";
import { syncAttributionToGA4 } from "@/lib/analytics";

export default function PublicAttributionCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const payload = buildAttributionPayload(
      window.location,
      document.referrer
    );
    const firstTouchStored = storeFirstTouchAttribution(payload);
    const lastTouchStored = storeLastTouchAttribution(payload);
    syncAttributionToGA4();

    if (process.env.NODE_ENV !== "production") {
      console.log("[attribution]", {
        first_touch: firstTouchStored,
        last_touch: lastTouchStored,
        payload,
      });
    }
  }, [pathname, search]);

  return null;
}
